import {Component, Input} from '@angular/core';
import {AssetVersionPipe} from '../../../../pipes/asset-version.pipe';

@Component({
  selector: 'app-source-display',
  imports: [
    AssetVersionPipe
  ],
  templateUrl: './source-display.component.html',
  styleUrl: './source-display.component.scss'
})
export class SourceDisplayComponent {
  @Input() source?: string;
  @Input() name?: string;
}
